<template>
 <div class="backdrop" @click.self="closeModal">

    <div id="twoColumnModalContent">
        <div id="heading">
            <div class="block" style="text-align:right;margin-bottom: 0;" @click="closeModal">
              <b-button type="is-primary" outlined rounded >Close</b-button>
            </div>
            <h1>Submit Your NIC</h1>
        </div>
        <div id="body">

<!--          TODO :: implement functionality to capture the images -->
            <template>
              <div id="signInModalBodyTopic">
                  <p>Note: You can save your NIC to make your sign work more secured.</p>
              </div>

                <div class="columns" style="overflow-y: scroll;position: relative; height: 300px;">
                    <div class="column" style="text-align:left;">
                        <p class="nicImageTitle">NIC front side image <span class="required">*</span></p>
                        <div class="nicImage nicFront">

                          <!--<div id="nicFrontImage"></div>-->

                            <!--<UploadNICModal  @on-captured="getUpoadedSignatureAsImage" :crop_ratio=7/4 file_name="customer_uploaded_signature" style="width: 50%; margin: auto;" />-->
                            <UploadNICModal  v-if="$root.customerData.nic_type == 'old-nic'" @on-nic-captured="onNICCaptured" :crop_ratio=9/14 file_name="nic_front_image" :selectedImageURL="$root.customerData.nicFrontImageURL" style="width: 100%; margin: auto;" />
                            <UploadNICModal  v-if="$root.customerData.nic_type == 'new-nic'" @on-nic-captured="onNICCaptured" :crop_ratio=14/9 file_name="nic_front_image" :selectedImageURL="$root.customerData.nicFrontImageURL" style="width: 100%; margin: auto;" />

                            <b-field
                                    :type="fieldValidation.nicFrontImage == ''? 'is-info' : 'is-danger'"
                                    :message="fieldValidation.nicFrontImage"
                                    style="padding-bottom: 10px;"
                            >
                            </b-field>
                            <!--<b-button type="is-primary" outlined rounded >Capture</b-button>-->

                        </div>

                    </div>
                    <div class="column" style="text-align:left; padding-left: 30px;">
                        <p class="nicImageTitle">NIC back side image <span class="required">*</span></p>
                      <div class="nicImage nicBack">

                        <!--<div id="nicBackImage"></div>-->

                          <UploadNICModal  @on-nic-captured="onNICBackCaptured" :crop_ratio=14/9 file_name="nic_back_image" :selectedImageURL="$root.customerData.nicBackImageURL" style="width: 100%; margin: auto;" />
                          <b-field
                                  :type="fieldValidation.nicBackImage == ''? 'is-info' : 'is-danger'"
                                  :message="fieldValidation.nicBackImage"
                                  style="padding-bottom: 10px;"
                          >
                          </b-field>
                          <!--<b-button type="is-primary" outlined rounded >Capture</b-button>-->

                      </div>
                    </div>
                </div>
                <div class="buttons">
                    <b-button type="is-primary" outlined rounded expanded @click="submitNicImages">Next</b-button>
                </div>
            </template>
        </div>
    </div>
 </div>
</template>

<script>

    import UploadNICModal from '@/components/frontend/UploadNICModal'

export default {

    components:{
        UploadNICModal
    },

    data(){
        return{
            // use to store input field validation status
           fieldValidation:{
             nicFrontImage:'',
             nicBackImage:'',
           },

           // variables to store field inputs
          nicFrontImage : null, // to store nicFrontImage initially null
          nicBackImage : null, // to store nicBackImage initially null

        }
    },

    methods:{
        closeModal:function(){
            this.$emit('close')
        },

        // method to validate the input fields
        validateFields:function (){
            var validNicFrontImage = true
            var validNicBackImage = true

            if(this.nicFrontImage == null){
              console.log("Invalid nic front image")
              this.fieldValidation.nicFrontImage = 'NIC front side image cannot be empty'
              validNicFrontImage = false
            }
            if(this.nicBackImage == null){
              console.log("Invalid nic back image")
              this.fieldValidation.nicBackImage = 'NIC back side image cannot be empty'
              validNicBackImage = false
            }

            if(validNicFrontImage && validNicBackImage){
              return true
            }
            else{
              return false
            }
        },

        submitNicImages : function(){

            if(this.validateFields()){
                // emit success event
                this.$emit('successCustomerNicCapture')
                console.log("NIC images capture success")
            }
            else {
                console.log("NIC images capture failed")
            }



        },


        resetInvalidFields : function(field){
             this.fieldValidation[field] =''
        },

        onNICCaptured: function (e){
            // alert(e)
            this.nicFrontImage = e
            this.$root.customerData.nicFrontImage = e
            this.fieldValidation.nicFrontImage = ''
            console.log("NIC front image : "+this.$root.customerData.nicFrontImage)
        },

        onNICBackCaptured: function (e){
            this.nicBackImage = e
            this.$root.customerData.nicBackImage = e
            this.fieldValidation.nicBackImage = ''
            console.log("NIC back image : "+this.$root.customerData.nicBackImage)
        },
    }


}

</script>

<style scoped>
    #twoColumnModalContent{
        margin: 10% auto;
        width: 800px;
        background: white;
        border-radius: 20px;
        min-height: 100px;
        line-height: normal;
        margin:auto;
        margin-top:10%;
        overflow-y: scroll;
    }

    #heading > h1{
        color:#0D5DA3;
        font-size: 22pt;
        margin: 0;
        font-weight: bold;
    }

    .backdrop{
        top: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
    }


   #signInModalBodyTopic > p {
    font-size:12pt;
    color: black;
    margin-bottom: 20px;
   }

   #heading{
        -webkit-box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46);
        box-shadow: 0px 5px 8px -5px rgba(0,0,0,0.46);
   }

    .nicImageTitle{
        color: #A5A6B3;
    }

    .nicImageTitleDanger{
      color: red;
    }

    #body{
        margin:  20px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 20px;
    }

    .nicImage{
      min-height: 200px;
      border: 1px solid #0D5DA3;
      text-align: center;
      align-items: center;
      padding-bottom: 10px;
    }

    #nicFrontImage , #nicBackImage{
      margin: 10px auto;
      width: 140px;
      height: 140px;
      /*background-image: url("../../assets/images/camera-placeholder.jpg");*/
      background-size: contain;
    }
</style>

<!-- Globally accessible CSS -->
<style>
.required{
  color: red;
}
</style>
